import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07991e49&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07991e49')) {
      api.createRecord('07991e49', component.options)
    } else {
      api.reload('07991e49', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07991e49&", function () {
      api.rerender('07991e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/profile/index.vue"
export default component.exports